
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.356 15.556L20 10l-6.644-5.556v4.024h-2.777v3.344h2.777v3.744z","fill":"#6A6482"}}),_c('path',{attrs:{"fill":"#6A6482","d":"M.383 1.675h9.035v16.649H.383z"}})])
          )
        }
      }
    